var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageScheduleWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.5,
    height: 19.5,
    viewBox: "0 0 19.5 19.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Scheduled_message_default_16px",
    "data-name": "Scheduled message_default_16px",
    transform: "translate(-368.605 -256.585)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3235",
    "data-name": "Group 3235",
    transform: "translate(369.355 257.335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1054",
    "data-name": "Path 1054",
    d: "M18.89,11.353a7.717,7.717,0,0,1-.844,3.536,7.941,7.941,0,0,1-7.1,4.368A7.794,7.794,0,0,1,7.4,18.415L2.08,20.179l1.77-5.3A7.876,7.876,0,0,1,7.39,4.273a7.946,7.946,0,0,1,3.077-.823",
    transform: "translate(-2.08 -2.179)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3234",
    "data-name": "Group 3234",
    transform: "translate(6.74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1055",
    "data-name": "Path 1055",
    d: "M20.271,5.355A5.632,5.632,0,1,1,15.14,2.05a6.07,6.07,0,0,1,2.225.49",
    transform: "translate(-9.51 -2.05)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1056",
    "data-name": "Path 1056",
    d: "M15.8,5.32V8.3h2.234",
    transform: "translate(-10.088 -2.351)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_132",
    "data-name": "Ellipse 132",
    cx: 0.518,
    cy: 0.518,
    r: 0.518,
    transform: "translate(9.035 1.053)",
    fill: "#787f88"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageScheduleWhiteIcon);
export default __webpack_public_path__ + "static/media/message-schedule-white-icon.8c455a257fc0ca4b58d0c243397aaae7.svg";
export { ForwardRef as ReactComponent };